import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Button, Grandmaster} from "lo-bahamut";
import { SharedModule } from '../_shared/shared.module';
import { CustomCarouselModule } from '../_shared/custom-carousel/custom-carousel.module';
import { ComingSoonModule } from '../coming-soon/coming-soon.module';
import {NlsLandingPageComponent} from "./nls-landing-page.component";
import {SearchStartV2Module} from "../search-start-v2/search-start-v2.module";
import {SearchStartModule} from "../search-start/search-start.module";
import {CarefindrAiModule} from "../carefindr-ai/carefindr-ai.module";
import {HttpClientModule} from "@angular/common/http";

@NgModule({
  declarations: [NlsLandingPageComponent],
  imports: [
    ComingSoonModule,
    CommonModule,
    SharedModule,
    CustomCarouselModule,
    Grandmaster,
    SearchStartV2Module,
    SearchStartModule,
    CarefindrAiModule,
    Button,
    HttpClientModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NlsLandingPageModule {}
